
import { Options, Vue } from "vue-class-component";
import ApiService from "../../services/ApiService";
import Header from "@/components/Header.vue";

@Options({
  components: {
    Header
  }
})
export default class LeaveOTP extends Vue {
  $keycloak: any; //globally defined in main.ts

  private apiService = new ApiService();

  async created() {
    try {
      await this.apiService.logoutOTP();
    } catch (error) {
      console.log(error);
    }
  }
}
